<template>
  <v-container>
    <PageHeader>
      <template v-slot:header>hitonobi</template>
    </PageHeader>

    <v-col v-if="isPurasu" cols="12" md="4">
      <SimpleCard color="#FCE8A5" icon="mdi-forum" title="プラスの氣">
        <template v-slot:text
          >行動や目標に対する取り組みに対しメッセージを送り合うことができます</template
        >
        <template v-slot:actions>
          <Button to="encouragements" color="primary"
            >プラスの氣を表示</Button
          ></template
        >
      </SimpleCard>
    </v-col>

    <v-col v-if="isJinji" cols="10" md="10">
      <h3 class="pt-2 pb-0 pl-2 pr-0">ToDo</h3>
      <v-row>
        <v-col cols="12" class="pt-0 pb-0 pl-5 pr-0">
          <p>
            <small
              >評価の情報を表示します。評価ボタンをクリックして評価を開始してください。</small
            >
          </p>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        :loading="loading"
        loading-text="読み込み中..."
        no-data-text="ToDoは見つかりませんでした。"
      >
        <template v-slot:[`item.BUTTON`]="{ item }">
          <Button
            color="secondary"
            class="mr-1"
            style="width: 50px"
            @click="edit(item)"
            :small="true"
            >評価</Button
          >
          <Button
            color="secondary"
            class="mr-1"
            style="width: 50px"
            @click="deleteTodoConfirm(item)"
            :small="true"
            >削除</Button
          >
        </template>
      </v-data-table>
    </v-col>

    <Loader :loading="loading" />
    <DialogMessage ref="dialog" />
    <ConfirmDialog
      ref="confirm"
      title="ToDo編集"
      :message="confirmMessage"
      @confirm="deleteToDoInfoRequest"
      buttonMessage="OK"
    >
    </ConfirmDialog>

    <Onboarding
      v-if="onboardingFlag"
      :overlay="onboardingFlag"
      @click="doneOnboarding"
      :position="position"
    />
  </v-container>
</template>

<script>
import axios from 'axios';
import config from '../const.js';
import message from '../message.js';
import moment from 'moment';
import { getSessionStorageItem, makeDateFormatStr } from '../common.js';
import Onboarding from '@/components/pages/Common/Onboarding.vue';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';

export default {
  name: 'toppage',

  components: {
    Onboarding,
    ConfirmDialog,
  },

  data() {
    return {
      loading: false,
      onboardingFlag: false,
      position: 'Junior',
      isPurasu: false,
      isJinji: false,
      confirmMessage: '',
      todoId: '',
      todoEvalKbn: '',
      items: [],
      headers: [
        {
          text: 'No.',
          value: 'TODO_NO',
          align: 'right',
        },
        {
          text: '発信日',
          value: 'TODO_SEND_DATE',
        },
        {
          text: '評価情報',
          value: 'TODO_REQUEST_COMMENT',
        },
        {
          text: '',
          value: 'BUTTON',
        },
      ],
    };
  },

  created() {
    // リロード
    const userInfo = getSessionStorageItem();
    if (userInfo) {
      // userInfoが取得できた場合、セッションIDを判定
      userInfo.SESSION_ID
        ? this.getOnboardingFlag(userInfo)
        : this.$router.push({ name: 'Login' });
    } else {
      this.$router.push({ name: 'Login' });
    }
  },

  methods: {
    async getOnboardingFlag(userInfo) {
      // 表示制御
      if (userInfo.ORGANIZATION_EXPIRATION == config.EXPIRATION_BOTH) {
        // 両方
        this.isPurasu = true;
        this.isJinji = true;
      } else if (
        userInfo.ORGANIZATION_EXPIRATION == config.EXPIRATION_PURASUNOKI
      ) {
        // プラスの氣のみ
        this.isPurasu = true;
        this.isJinji = false;
      } else if (userInfo.ORGANIZATION_EXPIRATION == config.EXPIRATION_JINJI) {
        // 人事考課のみ
        this.isPurasu = false;
        this.isJinji = true;
      }

      this.loading = true;
      await axios
        .get(config.CONNECT_URL + '/onboarding/' + userInfo.SESSION_ID)
        .then((res) => {
          this.onboardingFlag = res.data[0].ONBOARDING_FLAG;
          this.position = res.data[0].POSITION;
          // owner、sysop以外
          if (
            userInfo.USER_RANK != config.USER_RANK_OWNER &&
            userInfo.USER_RANK != config.USER_RANK_SYSOP
          ) {
            // TODOリスト取得
            this.getTodo();
            // ユーザ情報更新
            this.updateUserInfo();

            // 代理ログイン判定
            let proxyLogin = sessionStorage.getItem(
              config.SESSION_PROXY_LOGIN_NAME
            );

            if (proxyLogin == config.PROXY_LOGIN_TRUE) {
              // 代理ログインの場合、初期化
              sessionStorage.setItem(
                config.SESSION_PROXY_LOGIN_NAME,
                config.PROXY_LOGIN_FALSE
              );
              // 代理ログインの場合、リロード
              this.$router.go(0);
            }
          }
        })
        .catch(() => {
          return;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async doneOnboarding() {
      this.onboardingFlag = false;
      const userInfo = getSessionStorageItem();

      // 初回アクセスのフラグを更新する
      await axios
        .post(config.CONNECT_URL + '/onboarding', {
          SESSION_ID: userInfo.SESSION_ID,
        })
        .then((res) => {
          this.onboardingFlag = res.data.ONBOARDING_FLAG;
          this.position = res.data.POSITION;
        })
        .catch(() => {
          return;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteTodoConfirm(item) {
      // 確認ダイアログ表示
      this.todoId = item.TODO_ID;
      this.todoEvalKbn = item.TODO_EVAL_KBN;
      this.confirmMessage =
        '[No.' + item.TODO_NO + ']のToDoを削除してよろしいですか？';
      this.$refs.confirm.open();
    },
    deleteToDoInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      //----- ToDo削除リクエストPOST
      axios
        .post(config.CONNECT_EVALUATIONS_URL + '/Evaluations/todo/delete', {
          SESSION_ID: userInfo.SESSION_ID,
          SESSION_USER_ID: userInfo.USER_ID,
          TODO_ID: this.todoId,
          TODO_EVAL_KBN: this.todoEvalKbn,
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = 'ToDoの削除処理が成功しました';
            this.$refs.dialog.open('info', msgStr);

            // ToDo再取得
            this.getTodo();
          }
        })
        .catch((error) => {
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          // ローディング画像終了
          this.loading = false;
        });
    },
    async getTodo() {
      this.loading = true;

      const userInfo = getSessionStorageItem();
      let vm = this;

      // ToDoリストを取得する
      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/todo/list/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID
        )
        .then((response) => {
          // スタッフデータ取得
          vm.items = response.data;
          var todoNo = 0;
          for (var i = 0; i < vm.items.length; i++) {
            // No.
            todoNo = todoNo + 1;
            vm.items[i].TODO_NO = todoNo;
            // 発信日
            vm.items[i].TODO_SEND_DATE = makeDateFormatStr(
              vm.items[i].TODO_SEND_DATE,
              '/',
              '/',
              ''
            );
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 404) {
            errStr = message.MSG_INFO_ORGANIZATION_NOT_FOUND;
            this.$refs.dialog.open('info', errStr);
          } else if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateUserInfo() {
      this.loading = true;
      const userInfo = getSessionStorageItem();
      var updateAt = moment().format('YYYYMMDDHHmmss');

      //----- ユーザ情報更新リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL + '/Evaluations/login/user/update',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,
            UPDATED_AT: updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;
          let msgStr = '';
          if (response.status != 200) {
            msgStr =
              'スタッフ様の部署、役職情報に不整合が発生している可能性があります。\n' +
              ' 管理者にお問合せをお願いします。';
            this.$refs.dialog.open('info', msgStr);
          }
        })
        .catch((error) => {
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          // ローディング画像終了
          this.loading = false;
        });
    },

    edit(item) {
      if (item.TODO_EVAL_KBN == config.TODO_EVAL_KBN_SELF) {
        // 自己評価
        this.$router.push({
          name: 'SelfEvaluationDetail',
          params: {
            goalId: Buffer.from(item.GOAL_ID).toString('base64'),
            userId: Buffer.from(item.USER_ID).toString('base64'),
            completeNo: Number(item.EVAL_NO_COMPLETE) + 1,
            entryKind: config.ENTRY_KIND_ENTRY,
          },
        });
      } else if (item.TODO_EVAL_KBN == config.TODO_EVAL_KBN_FIRST) {
        // 一次評価
        this.$router.push({
          name: 'FirstEvaluationDetail',
          params: {
            goalId: Buffer.from(item.GOAL_ID).toString('base64'),
            userId: Buffer.from(item.USER_ID).toString('base64'),
            completeNo: Number(item.EVAL_NO_COMPLETE) + 1,
            entryKind: config.ENTRY_KIND_ENTRY,
          },
        });
      } else {
        // 二次評価
        this.$router.push({
          name: 'SecondEvaluationDetail',
          params: {
            goalId: Buffer.from(item.GOAL_ID).toString('base64'),
            userId: Buffer.from(item.USER_ID).toString('base64'),
            entryKind: config.ENTRY_KIND_ENTRY,
          },
        });
      }
    },
  },
};
</script>
